module.exports = __webpack_public_path__ + "img/48_11.02e51399.png";